import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ArrowRightIcon from "@material-ui/icons/ArrowRight";
import DeleteIcon from "@material-ui/icons/Delete";
import DraftsIcon from "@material-ui/icons/Drafts";
import Label from "@material-ui/icons/Label";
import MailIcon from "@material-ui/icons/Mail";
import { TreeItem } from "@material-ui/lab";
import TreeView from "@material-ui/lab/TreeView";
import PropTypes from "prop-types";
import React from "react";

const useTreeItemStyles = makeStyles((theme) => ({
	root: {
		color: theme.palette.text.secondary,
		"&:hover > $content": {
			backgroundColor: theme.palette.action.hover,
		},
		"&:focus > $content, &$selected > $content": {
			backgroundColor: `var(--tree-view-bg-color, ${theme.palette.grey[400]})`,
			color: "var(--tree-view-color)",
		},
		"&:focus > $content $label, &:hover > $content $label, &$selected > $content $label": {
			backgroundColor: "transparent",
		},
	},
	content: {
		color: theme.palette.text.secondary,
		borderTopRightRadius: theme.spacing(2),
		borderBottomRightRadius: theme.spacing(2),
		paddingRight: theme.spacing(1),
		fontWeight: theme.typography.fontWeightMedium,
		"$expanded > &": {
			fontWeight: theme.typography.fontWeightRegular,
		},
	},
	group: {
		marginLeft: 0,
		"& $content": {
			paddingLeft: theme.spacing(2),
		},
	},
	expanded: {},
	selected: {},
	label: {
		fontWeight: "inherit",
		color: "inherit",
	},
	labelRoot: {
		display: "flex",
		alignItems: "center",
		padding: theme.spacing(0.5, 0),
	},
	labelIcon: {
		marginRight: theme.spacing(1),
	},
	labelText: {
		fontWeight: "inherit",
		flexGrow: 1,
	},
}));

const styled = { TreeView: { bgColor: "#FFFAFA" } };

function StyledTreeItem(props) {
	const classes = useTreeItemStyles();
	const {
		labelText,
		labelIcon: LabelIcon,
		labelInfo,
		color,
		bgColor,
		...other
	} = props;

	return (
		<TreeItem
			label={
				<div className={classes.labelRoot}>
					<LabelIcon color="inherit" className={classes.labelIcon} />
					<Typography variant="body2" className={classes.labelText}>
						{labelText}
					</Typography>
					<Typography variant="caption" color="inherit">
						{labelInfo}
					</Typography>
				</div>
			}
			style={{
				"--tree-view-color": color,
				"--tree-view-bg-color": bgColor,
			}}
			classes={{
				root: classes.root,
				content: classes.content,
				expanded: classes.expanded,
				selected: classes.selected,
				group: classes.group,
				label: classes.label,
			}}
			{...other}
		/>
	);
}

StyledTreeItem.propTypes = {
	bgColor: PropTypes.string,
	color: PropTypes.string,
	labelIcon: PropTypes.elementType.isRequired,
	labelInfo: PropTypes.string,
	labelText: PropTypes.string.isRequired,
};

const useStyles = makeStyles({
	root: {
		height: 264,
		flexGrow: 1,
		maxWidth: 400,
	},
});

export default function LeftMenuTree(props) {
	const classes = useStyles();

	return (
		<TreeView
			className={classes.root}
			defaultExpanded={["3"]}
			defaultCollapseIcon={<ArrowDropDownIcon />}
			defaultExpandIcon={<ArrowRightIcon />}
			defaultEndIcon={<div style={{ width: 24 }} />}
			bgcolor="#e8f0fe"
		>
			<StyledTreeItem
				nodeId="1"
				labelText="All Docs"
				labelIcon={MailIcon}
				onClick={props.showAllDocs}
			/>
			<StyledTreeItem
				nodeId="2"
				labelText="Draft"
				labelIcon={DraftsIcon}
				onClick={props.showDraftDocs}
			/>
			<StyledTreeItem
				nodeId="3"
				labelText="Trash"
				labelIcon={DeleteIcon}
				onClick={props.showTrashDocs}
			/>

			<StyledTreeItem nodeId="4" labelText="History" labelIcon={Label} />
		</TreeView>
	);
}
